// extracted by mini-css-extract-plugin
module.exports = {"illustration":"styles-module__illustration___14aaP"};